/** @jsx jsx */
import { jsx } from "theme-ui";
import { GatsbyImage } from "gatsby-plugin-image";

const FluidImage = ({image, alt, className}) => {
  const style = {
    borderRadius: "4px",
  };

  return image ?
    image.childImageSharp ?
      // For bitmaps
      <GatsbyImage 
        image={image.childImageSharp.gatsbyImageData} 
        alt={alt} 
        className={className}
        sx={style} 
      /> :
      // For SVGs
      <img
        src={image.publicURL}
        alt={alt}
        className={className}
        sx={style}        
      />
    :
    null;
};

export default FluidImage;
